import React from 'react';

import { Typography } from '@mui/material';

import LeadDaysCalendar from '~/components/Vendors/Properties/LeadDaysCalendar';

import { useGetRoomRateLeadDays } from '~/hooks/apis/reservation/useGetRoomRateLeadDays';

interface Props {
  propertyId: string;
  roomType: App.RoomType;
  roomRate: App.RoomRate;
}

export default function LeadDaysTab({ propertyId, roomType, roomRate }: Props) {
  const { data: leadDays = [] } = useGetRoomRateLeadDays(propertyId, roomType.id, roomRate.id);

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Lead days apply to channel-managed Flash offers only, so they are not configurable for this room rate.
      </Typography>

      {leadDays.length !== 0 && <LeadDaysCalendar leadDays={leadDays} />}
    </>
  );
}
